/**
 * Giriş kapısı.
 *
 * Masaya kimlerin oturacağını belirleyen özel soru — herkese açık bir oyun
 * değil, tanıdıklar arasında oynanıyor. Kapıyı istemcide tutmak sunucu
 * doğrulamasının yerini TUTMAZ; amaç yabancıyı içeri almamak, saldırganı
 * durdurmak değil. Online masa açıldığında gerçek kimlik sunucuda doğrulanacak.
 *
 * `ACCESS_ANSWER` boş bırakılırsa kapı açık kalıyor: geliştirme sırasında
 * cevabı bilmeden test edilebilsin.
 */

export const ACCESS_QUESTION = 'Mete’nin ilkokul numarası';

/** Doğru cevap. Boşsa her cevap kabul edilir. */
export const ACCESS_ANSWER = '';

export const checkAccess = (value: string): boolean =>
  ACCESS_ANSWER === '' || value.trim() === ACCESS_ANSWER;
